<template>
  <div v-if="start">
    <div v-if="!currentOperator">
      <p>Такого оператора не существует</p>
    </div>
    <div v-else class="lg:w-3/4">
      <vx-card class="lg:p-8 w-full mb-6">
        <div class="vx-card__title mb-4">
          <h4 class="mb-4">Редактирование оператора</h4>
          <p>Дополните или замените информацию об операторе.</p>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Имя: *"
              name="firstName"
              v-model="firstName"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('firstName')">{{ errors.first('firstName') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Фамилия:"
              v-model="lastName"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <password-input
              label="Пароль:"
              name="password"
              v-model="password"
              v-validate="'min:8'"
              ref="password"
              class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <password-input
              label="Подтвердить пароль:"
              name="password_confirmation"
              v-model="password_confirmation"
              data-vv-as="password"
              v-validate="'confirmed:password'"
              class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
          </div>
        </div>

        <UploadFile
          v-model="profileImageKey"
        />

        <operators-edit-groups
          :company-slug="authUserCompany.slug"
          :operators-email="currentOperator.email"
          :operators-groups="groups"
        />

        <div class="flex justify-end mt-6">
          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            @click.prevent="submitSave">
            Сохранить
          </vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Operators from '../../api/http/models/Operators'
import { mapGetters } from 'vuex'
import OperatorsEditGroups from './OperatorsEditGroups'
import UploadFile from '../../components/UploadFile'

export default {
  data () {
    return {
      start: false,
      currentOperator: null,
      firstName: '',
      lastName: '',
      password: '',
      password_confirmation: '',
      groups: [],
      profileImageKey: ''
    }
  },
  computed: {
    ...mapGetters(['authUserCompany']),
    name () {
      return this.lastName ? `${this.firstName} ${this.lastName}` : this.firstName
    }
  },
  components: {
    OperatorsEditGroups,
    UploadFile
  },
  methods: {
    async submitSave () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        const updated = await Operators.updateOne(this.authUserCompany.slug, this.currentOperator.email, {
          name: this.name,
          password: this.password || null,
          profile_image_key: this.profileImageKey || null
        })

        if (updated.status === 'success') {
          this.$router.push({ name: 'operators' })
        }
      }
    }
  },
  async created () {
    const operators = await Operators.getOne(this.authUserCompany.slug, this.$route.params.email)
    if (operators.data) {
      this.currentOperator = operators.data
      this.firstName = this.currentOperator.name.split(' ')[0]
      this.lastName = this.currentOperator.name.split(' ')[1] || ''
      this.groups = this.currentOperator.groups
      this.profileImageKey = this.currentOperator.profile_image_key
    }

    this.start = true
  }
}
</script>
